import React, { useState, useEffect } from 'react';

// Generate past N week ranges ending on Sundays
const getLastNSundays = (n) => {
    const weeks = [];
    const today = new Date();
    const lastSunday = new Date(today.setDate(today.getDate() - today.getDay()));

    for (let i = 0; i < n; i++) {
        const sunday = new Date(lastSunday);
        sunday.setDate(sunday.getDate() - 7 * i);

        const monday = new Date(sunday);
        monday.setDate(sunday.getDate() - 6);

        const label = `${monday.toLocaleDateString('en-GB')} -> ${sunday.toLocaleDateString('en-GB')}`;
        const value = sunday.toISOString().split('T')[0]; // yyyy-mm-dd

        weeks.push({ label, value });
    }

    return weeks;
};

const WeeklyStorageReport = ({ fetchReports }) => {
    const [weekEnding, setWeekEnding] = useState('');
    const [weeksList, setWeeksList] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        setWeeksList(getLastNSundays(52));
    }, []);

    const handleSubmit = () => {
        if (!weekEnding) {
            setError('Please select a week range!');
            return;
        }

        setError('');
        fetchReports({ week_ending: weekEnding });
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px', // Ensures a minimum height

        }}>
            <h2>Weekly Storage Report</h2>

            <select
                value={weekEnding}
                onChange={(e) => setWeekEnding(e.target.value)}
                style={{ padding: '5px', textAlign: 'center' }}
            >
                <option value="">Select Week</option>
                {weeksList.map(({ label, value }) => (
                    <option key={value} value={value}>{label}</option>
                ))}
            </select>

            <button
                className="hoverable"
                onClick={handleSubmit}
                style={{
                    padding: '5px 10px',
                    width: '100%',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                Submit
            </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default WeeklyStorageReport;
